// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__Fl2VY","name":"ConsentHeader_name__ANG_y","birthday":"ConsentHeader_birthday__1r4Na","skeleton":"ConsentHeader_skeleton__2gF01"};